import Vue from "vue"
import Vuex from "vuex"

import auth from "./modules/auth"
import common from "./modules/common"
import messenger from "./modules/messenger"
import meta from "./modules/meta"
import notifications from "./modules/notifications"
import user from "./modules/user"
import mutationSharer from "./plugins/mutationSharer"

Vue.use(Vuex)

const store = new Vuex.Store<any>({
  modules: {
    common,
    auth,
    user,
    meta,
    notifications,
    messenger
  },

  plugins: [mutationSharer]
})

export default store
